
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casino/favourites",
      function () {
        return require("private-next-pages/casino/favourites/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casino/favourites"])
      });
    }
  